import { createContext, useContext, useState } from 'react'
import { DEFAULT_CATEGORIES } from './constants'

const SettingsContext = createContext(null)

export function SettingsProvider({ children }) {
  const [showHomeTotals, setShowHomeTotals] = useState(true)
  const [showRoomTotals, setShowRoomTotals] = useState(true)
  const [categories, setCategories] = useState(DEFAULT_CATEGORIES)

  const activeCategories = categories.filter(c => c.active)

  const toggleCategory = (key, val) => {
    const activeCount = categories.filter(c => c.active).length
    if (!val && activeCount <= 1) return
    setCategories(prev => prev.map(c => c.key === key ? { ...c, active: val } : c))
  }

  const addCategory = (cat) => {
    setCategories(prev => [...prev, cat])
  }

  const deleteCategory = (key) => {
    setCategories(prev => prev.filter(c => c.key !== key))
  }

  return (
    <SettingsContext.Provider value={{
      showHomeTotals, setShowHomeTotals,
      showRoomTotals, setShowRoomTotals,
      categories, activeCategories,
      toggleCategory, addCategory, deleteCategory,
    }}>
      {children}
    </SettingsContext.Provider>
  )
}

export const useSettings = () => useContext(SettingsContext)
